export default "__VITE_ASSET__L38zahj6__"